import { useState, useEffect } from 'react';
import { makeStyles, Grid, Box, Dialog, Divider, withStyles, Button, Theme, createStyles, TextField } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { addUser } from "../../../../store/actions/admin/user";
import { useDispatch, useSelector } from "react-redux";
import ValidateForm from "../../../../helper/validations";
import { getBillingDetails } from "../../../../store/actions/admin/user";
import Config from "../../../../config/config";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center'
    }
  });

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '24px!important'
  },
  createBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#0179EE',
    color: '#FFFFFF',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0f9fef'
    },
  },
  cancelBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#e0e0e0',
    },
  },


}));

const UserModel = ({ open, onClose }: any) => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};
  const { billingDetails } = useSelector((state: any) => state.adminUser);
  const [BillingDetails, setBillingDetails] = useState<any>();

  useEffect(() => {
    const request = { username: loginUserData.username };
    dispatch(getBillingDetails(apolloClient.client, request));
  }, [apolloClient.client, dispatch, loginUserData.user_id]);

  useEffect(() => {
    if (billingDetails) {
      setBillingDetails(billingDetails);

      console.log(BillingDetails);

    }
  }, [billingDetails]);

  const [state, setState] = useState({
    firstName: "",
    lastName: "",
    username: "",
    loading: false,
    errors: { firstname: "", lastname: "", username: "" },
  });


  //Method call on create role button
  const onAddUser = () => {

    let admin_role_name = "";

    if(loginUserData && loginUserData.role_access){
      if(loginUserData.role_access.length){
        const admin_user = loginUserData.role_access.filter((val:any) => val.access_name === "admin_users");
        if(admin_user.length > 0 && admin_user[0].access_value){
          admin_role_name = "admin_users"
        }
        else{
          const trial_admin = loginUserData.role_access.filter((val:any) => val.access_name === "trial_admin");
          if(trial_admin.length > 0 && trial_admin[0].access_value){
            admin_role_name = "trial_admin"
          }
        }
      }
    }

    let prepaid = false;
    if (!!BillingDetails) {
      /*if (BillingDetails.data.stripe_plan_id.includes("known")) {
        prepaid = true;
      }*/

      if (BillingDetails.data && BillingDetails.data.stripe_plan_id && BillingDetails.data.stripe_plan_id.includes("known")) {
        prepaid = true;
      } else if (BillingDetails.data && BillingDetails.data.stripe_plan_id && BillingDetails.data.stripe_plan_id.includes("lively")) {
        prepaid = true;
      }
    }
    console.log("i am prepaid: " + prepaid);

    const request = {
      firstname: state.firstName,
      lastname: state.lastName,
      username: !!state.username && state.username.toLowerCase().trim(),
      middlename: "",
      display: "",
      customername: loginUserData.customer_name,
      systemflag: loginUserData.system_flagged,
      adminemail: true,
      department_id: parseFloat(loginUserData.department_id),
      admin_role_name: admin_role_name,
      prepaid: prepaid,
      billing_subscription_id: (prepaid ? BillingDetails.data.stripe_subscription_id : null),
      subbrand: Config.DEFAULT_SUBBRAND
    };
    const validateError = ValidateForm.validateUserForm(request)
    if (!Object.keys(validateError).length) {
      setState(prevState => ({
        ...prevState,
        "loading": true
      }));
      dispatch(addUser(apolloClient.client, request));
      onClose()

    } else {
      setState(prevState => ({
        ...prevState,
        errors: validateError
      }));
    }


  };

  // Call method on input change
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const errors = state.errors;

    if (value === "") {
      if (name === "firstName") {
        errors["firstname"] = "Please enter your first name";
      }
    } else if (value !== "" && name === "firstName") {
      errors["firstname"] = ""
    }

    if (value === "") {
      if (name === "lastName") {
        errors["lastname"] = "Please enter your last name";
      } else { errors["lastname"] = "" }
    } else if (value !== "" && name === "lastName") {
      errors["lastname"] = ""
    }
    if (value === "") {
      if (name === "username") {
        errors["username"] = "Please enter your email";
      } else { errors["username"] = "" }
    } else if (value !== "" && name === "username") {
      errors["username"] = ""
    }
    setState(prevState => ({
      ...prevState,
      [name]: value,
      errors: {
        ...state.errors,
        firstname: errors["firstname"],
        lastname: errors["lastname"],
        username: errors["username"],
      },
    }));
  };


  const DialogTitle = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;

    

    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <div className={classes.header}>
          {children}
          {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
              <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
            </IconButton>
          ) : null}
        </div>
      </MuiDialogTitle>
    );
  });

  return (
    <div>
      <Grid container>
        <Grid item>
          <Dialog
            
            disableEscapeKeyDown
            fullWidth={true}
            maxWidth={'sm'}
            open={open}
            className="modal-custom"
            scroll="body"
          >
            <div>
              <DialogTitle onClose={onClose}>
                Create a user
        			</DialogTitle>
              <Divider />

              <Box m={4} pl={1} pr={1}>
                <TextField
                  value={state.firstName}
                  fullWidth
                  margin="normal"
                  id="firstName"
                  label="First Name"
                  name="firstName"
                  onChange={(e) => handleChange(e)}
                  error={state.errors && state.errors.firstname ? true : false}
                  helperText={state.errors.firstname ? state.errors.firstname : ""}
                />
                <TextField
                  value={state.lastName}
                  fullWidth
                  margin="normal"
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  onChange={(e) => handleChange(e)}
                  error={state.errors && state.errors.lastname ? true : false}
                  helperText={state.errors.lastname ? state.errors.lastname : ""}
                />
                <TextField
                  value={state.username}
                  fullWidth
                  margin="normal"
                  id="username"
                  label="Email"
                  name="username"
                  onChange={(e) => handleChange(e)}
                  error={state.errors && state.errors.username ? true : false}
                  helperText={state.errors.username ? state.errors.username : ""}
                />

              </Box>
              <Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
                <Button onClick={onClose}>
                  Cancel
								</Button>&nbsp;&nbsp;&nbsp;
                <Button
                  onClick={() => onAddUser()}
                  disabled={state.loading ? true : false}
                  className={classes.createBtn}
                >
                  Create
								</Button>
              </Box>
            </div>
          </Dialog>
        </Grid>
      </Grid>
    </div>
  )
}
export default UserModel;

